export const getRegion = () => {
  let region = localStorage.getItem('region'); // dev method

  if (!region) {
    region = getDefinedRegion();
    localStorage.setItem('region', region);
  }

  return region;
};

function getDefinedRegion() {
  const host = window.location.host;

  switch (host) {
    case 'localhost:3000':
    case 'sixtix.com':
      return 'com';

    case 'sixtix.rs':
      return 'rs';

    case 'sixtix.fr':
      return 'fr';

    case 'sixtix.nl':
      return 'nl';

    default:
      return 'com';
  }
}
